import { Controller } from "@hotwired/stimulus"

// Multi-currency price management: add/remove currency rows with dropdown selection.
//
// Uso en ERB (via helper currency_prices_field):
//   <%= currency_prices_field(
//     currencies: ["CLP", "USD", "EUR"],
//     prices: { "CLP" => 10000 },
//     input_name: "prices",
//     placeholder: "Ingresa un precio"
//   ) %>
//
// Targets:
//   row        — cada fila de precio (con data-currency="XXX")
//   option     — cada item del dropdown (con data-currency="XXX")
//   addWrapper — contenedor del botón + menú "Agregar"
//   menu       — panel del dropdown

export default class extends Controller {
  static targets = ["row", "option", "addWrapper", "menu"]
  static values = {
    currencies: Array
  }

  connect() {
    this._clickOutside = (e) => {
      if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden") &&
          this.hasAddWrapperTarget && !this.addWrapperTarget.contains(e.target)) {
        this.menuTarget.classList.add("hidden")
      }
    }
    document.addEventListener("click", this._clickOutside)
    this.refreshDropdown()
  }

  disconnect() {
    document.removeEventListener("click", this._clickOutside)
  }

  toggleMenu(event) {
    event.stopPropagation()
    if (!this.hasMenuTarget) return
    this.menuTarget.classList.toggle("hidden")
  }

  // Muestra una moneda específica seleccionada desde el dropdown
  addCurrency(event) {
    const currency = event.currentTarget.dataset.currency
    if (!currency) return

    const row = this.rowTargets.find(
      (r) => r.dataset.currency === currency && r.classList.contains("hidden")
    )
    if (!row) return

    this.enableRow(row)
    if (this.hasMenuTarget) this.menuTarget.classList.add("hidden")
    this.refreshDropdown()
  }

  // Fallback: muestra la primera moneda oculta (para uso sin dropdown)
  add() {
    const hiddenRow = this.rowTargets.find(
      (row) => row.classList.contains("hidden")
    )
    if (!hiddenRow) return

    this.enableRow(hiddenRow)
    this.refreshDropdown()
  }

  remove(event) {
    const row = event.target.closest("[data-manage--multi-currency-target='row']")
    if (!row) return

    row.classList.add("hidden")
    row.querySelectorAll("input").forEach((input) => {
      input.disabled = true
      input.value = ""
    })

    this.refreshDropdown()
  }

  enableRow(row) {
    row.classList.remove("hidden")
    const display = row.querySelector("[data-manage--number-format-target='display']")
    const raw = row.querySelector("[data-manage--number-format-target='raw']")
    if (raw) {
      raw.disabled = false
      if (!raw.value) raw.value = "0"
    }
    if (display) {
      display.disabled = false
      if (!display.value) display.value = "0"
      display.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  refreshDropdown() {
    if (!this.hasOptionTarget) return

    const visibleCurrencies = this.rowTargets
      .filter((r) => !r.classList.contains("hidden"))
      .map((r) => r.dataset.currency)

    let availableCount = 0
    this.optionTargets.forEach((option) => {
      const used = visibleCurrencies.includes(option.dataset.currency)
      option.classList.toggle("hidden", used)
      if (!used) availableCount++
    })

    // Ocultar el wrapper completo si no quedan monedas disponibles
    if (this.hasAddWrapperTarget) {
      this.addWrapperTarget.classList.toggle("hidden", availableCount === 0)
    }
  }
}
